import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stickyBar: {
            width: '100%',
            bg: 'background.base.default',
            borderTop: 'small',
            borderStyle: 'solid',
            borderTopColor: 'border.neutral.default',
            px: ['xsmall.base', 'xsmall.base', 'medium.lg', 'medium.xl'],
            py: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.lg', 'xxsmall-1.xl'],
        },
        stickyBarContent: {
            width: '100%',
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.lg', 'xxsmall-1.xl'],
            flexWrap: {base: 'wrap', md: 'nowrap'},
        },
        productContainer: {
            display: 'flex',
            flex: 1,
            minWidth: 0,
        },
        imageContainer: {
            display: {base: 'none', md: 'flex'},
            gap: {base: remCalc(15), lg: remCalc(26), xl: remCalc(40)},
            marginRight: {base: 'none', xl: remCalc(40)},
            flex: '0',
        },
        productImage: {
            width: `${remCalc(75)}`,
            height: `${remCalc(85)}`,
            display: {base: 'none', lg: 'block'},
            borderRadius: 'large-1',
            mixBlendMode: 'multiply',
        },
        productText: {
            fontWeight: 'medium',
            textStyle: 'body-large',
            color: 'foreground.neutral.default',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: 1,
        },
        productSubtitleText: {
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
            textStyle: 'body-large',
        },
        productTextCode: {
            textStyle: 'body-small',
            color: 'foreground.neutral.secondary',
        },
        actionsContainer: {
            display: 'flex',
            flexDir: {base: 'column', md: 'row'},
            alignItems: {base: 'stretch', md: 'center'},
            justifyContent: {base: 'flex-start', md: 'flex-end'},
            gap: ['xxsmall-1.base', 'xxsmall-1.sm', 'xxsmall-1.lg', 'xxsmall-1.xl'],
            width: {base: '100%', md: 'auto'},
            order: {base: 2, md: 2},
        },
        priceContainer: {
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.lg', 'xxxsmall.xl'],
            alignItems: {base: 'flex-start', md: 'flex-end'},
            justifyContent: 'flex-start',
            flexWrap: 'nowrap',
            width: {base: '100%', md: 'auto'},
            order: 'unset',
            flexDir: 'column',
        },
        priceMainRow: {
            display: 'flex',
            alignItems: 'center',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.lg', 'xxxsmall.xl'],
        },
        omnibusContainer: {
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.lg', 'xxxsmall.xl'],
            alignItems: 'center',
        },
        infoIcon: {
            width: remCalc(16),
            height: remCalc(16),
            color: 'foreground.neutral.default',
            alignSelf: 'center',
        },
        sectionButtonGroup: {
            display: {base: 'grid', lg: 'flex'},
            gap: {base: `${remCalc(4)} ${remCalc(16)}`, xl: `${remCalc(16)}`},
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        sectionButton: {
            color: 'foreground.neutral.muted',
            textStyle: 'body-medium',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
        },
        buttonContainer: {
            order: 'unset',
        },
    },
    variants: {
        paperless: {
            stickyBar: {
                overflow: 'auto',
                padding: `${remCalc(24)} ${remCalc(16)}`,
            },
            sectionButton: {
                whiteSpace: 'nowrap',
                _hover: {textDecoration: 'underline'},
                _last: {marginRight: {base: 'small.sm', lg: 'unset'}},
            },
            productText: {
                marginBottom: 'unset',
                whiteSpace: {
                    base: 'wrap',
                    lg: 'normal',
                },
                width: remCalc(250),
            },
            stickyBarContent: {
                flexDir: {
                    base: 'row',
                    lg: 'row',
                },
                gap: {
                    base: 'small.base',
                    lg: remCalc(115),
                },
                paddingTop: remCalc(0),
            },
            sectionButtonGroup: {
                display: 'flex',
                color: 'foreground.neutral.muted',
            },
        },
        plpSticky: {
            buttonContainer: {
                flex: {base: '1', md: '0'},
                h: remCalc(40),
                ml: {base: 'unset', lg: 'auto'},
            },
            buttonLabel: {
                p: `${remCalc(10)} ${remCalc(24)}`,
                overflow: {base: 'hidden', md: 'visible'},
                textOverflow: {base: 'ellipsis', md: 'unset'},
                display: 'block',
                maxWidth: 'fit-content',
            },
            stickyBar: {
                padding: {
                    base: `${remCalc(24)} ${remCalc(16)}`,
                    md: `${remCalc(7)} ${remCalc(24)}`,
                    lg: `${remCalc(7)} ${remCalc(24)}`,
                    xl: `${remCalc(7)} 0`,
                },
            },
            stickyBarContent: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: {base: 'space-between', lg: 'initial'},
                gap: {base: remCalc(8), md: 0},
            },
            productContainer: {
                gap: remCalc(40),
                alignItems: 'center',
            },

            productText: {
                marginBottom: 'unset',
                textAlign: {base: 'left', md: 'center', xl: 'left'},
                whiteSpace: 'normal',
            },
            productImage: {
                display: {base: 'none', md: 'block'},
            },
        },
    },
    parts: [
        'stickyBar',
        'stickyBarContent',
        'productContainer',
        'productImage',
        'productText',
        'productSubtitleText',
        'productTextCode',
        'actionsContainer',
        'priceContainer',
        'priceMainRow',
        'omnibusContainer',
        'infoIcon',
        'sectionButtonGroup',
        'sectionButton',
        'buttonContainer',
        'buttonLabel',
    ],
}
